module.exports = __webpack_public_path__ + "img/qiandao.56516f39.png";